import { getConfigFromJson } from './getConfigFromJson';
import { PAGES_TITLE } from './utils/constants';

export const configureAuthAndLayout = async () => {
  // the config and auth modules are imported in order to configure auth and pass props to MFEs.

  const appConfig = await getConfigFromJson('@nlhr/app-config');

  window.addEventListener('single-spa:routing-event', () => {
    const currentRoute = window.location.pathname;
    if (
      !(
        currentRoute.startsWith('/app') ||
        currentRoute === '/' ||
        currentRoute === '' ||
        currentRoute === '/login'
      )
    ) {
      document.title = PAGES_TITLE[currentRoute] || 'Next Level HR';
    }
  });

  // add our application

  const NlhrDashboardRoute = {
    type: 'route',
    path: '/',
    routes: [
      {
        type: 'div',
        attrs: [{ name: 'id', value: 'nlhr-main-content-with-footer' }],
        routes: [
          {
            type: 'application',
            name: '@nlhr/main',
            props: {
              baseUrl: appConfig.appProps.baseUrl,
              apiUrl: appConfig.apiUrl,
              featureFlagProps: appConfig.featureFlagProps,
              piamv2Props: appConfig.piamv2Props,
              emConfig: appConfig.messengerConfig
            },
          },
        ],
      },
    ],
  };

  // the routes are tied together into a layout object that is exported and can be used by single spa
  // https://single-spa.js.org/docs/layout-definition#single-spa-router
  const layout = {
    base: appConfig.appProps.baseUrl,
    routes: [
      {
        type: 'main',
        attrs: [{ name: 'id', value: 'main-page' }],
        routes: [NlhrDashboardRoute],
      },
    ],
  };

  return {
    appConfig: appConfig,
    layout,
    navigate: '',
    applicationId: appConfig.appProps.applicationId,
  };
};
